<template>
  <div class='HandleRole'>
    <div class="header">
      <div class="headerTitle">
        <h4>角色信息</h4>
        <span>（设置角色对应的功能操作、应用管理、后台管理权限）</span>
      </div>
      <div class="headerHint">
        <span>*</span>为必填项
      </div>
    </div>
    <div class="roleName">
      <div class="title">
        <span>*</span>角色名称
      </div>
      <el-row>
        <el-col :span="6">
          <el-input size="small"
                    type="text"
                    v-model="roleName"
                    placeholder="请输入内容"
                    maxlength="10" />
        </el-col>
        <el-col :span="6"
                class="hint">{{0}}/10</el-col>
      </el-row>
    </div>
    <div class="roleDescription">
      <div class="title">角色描述</div>
      <el-row>
        <el-col :span="13">
          <el-input size="small"
                    type="textarea"
                    v-model="remark"
                    placeholder="请输入内容"
                    maxlength="200" />
        </el-col>
        <div class="hint">0/200</div>
      </el-row>
    </div>

    <div class="menu">
      <div class="menuTitle">
        <h4>权限划分</h4>
      </div>
      <el-tree :data="treeData"
               class="elTree"
               show-checkbox
               node-key="id"
               ref="elTree"
               :props="defaultProps"
               :default-expand-all="true">
      </el-tree>
    </div>

    <div class="handle">
      <div class="btn">
        <el-button size="medium"
                   @click="toSetRole">取消</el-button>
        <el-button type="primary"
                   size="medium"
                   @click="confirm">确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      treeData: [],
      roleName: null,
      remark: null,
      defaultProps: {
        children: 'children',
        label: 'menuName'
      },
      roleLastid: []
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    async getMenuList () {
      await this.$http.getMenuList()
        .then((res) => {
          if (res.status === 200) {
            this.treeData = res.data
          }
        })
    },
    confirm () {
      const res = this.$refs.elTree.getCheckedNodes()
      const Halfres = this.$refs.elTree.getHalfCheckedKeys()
      let arr = []
      arr = res.map(item => {
        return item.id
      })
      arr = arr.concat(Halfres)
      if (!this.roleName) {
        this.$message.warning('请输入角色名称')
        return
      }

      const params = {
        roleName: this.roleName,
        remark: this.remark,
        roleKey: arr.join(','),
        id: this.$route.query.id
      }

      if (this.$route.query.id) {
        this.changeRole(params)
      } else {
        this.addRole(params)
      }
    },

    // 添加接口
    addRole (params) {
      this.$http.addRole(params)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg)
            this.toSetRole()
          }
        })
    },

    // 修改接口
    changeRole (params) {
      this.$http.changeRole(params)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg)
            this.toSetRole()
          }
        })
    },

    // 调用详情接口
    getRoleInfo (id) {
      const selectElement = []
      const params = {
        id
      }
      this.$http.getRoleInfo(params)
        .then((res) => {
          if (res.status === 200) {
            this.roleName = res.data.roleName
            this.remark = res.data.remark
            const roleKey = (res.data.roleKey || '').split(',')
            this.getRoleLastElement(this.treeData)
            this.roleLastid.forEach(ele => {
              if (roleKey.includes(ele.toString())) {
                selectElement.push(ele)
              }
            })

            this.$refs.elTree.setCheckedKeys(selectElement)
          }
        })
    },

    // 获取权限子元素
    getRoleLastElement (ele) {
      if (!Array.isArray(ele)) return
      ele.forEach(e => {
        if (e.children) {
          this.getRoleLastElement(e.children)
        } else {
          this.roleLastid.push(e.id)
        }
      })
    },

    toSetRole () {
      this.$router.push('/setting/role')
    },

    async init () {
      await this.getMenuList()
      const id = this.$route.query.id
      if (id) {
        this.getRoleInfo(id)
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.init()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.HandleRole {
  position: relative;
  height: 100%;
  margin: 20px;
  background-color: #fff;
  .header {
    height: 55px;
    width: 100%;
    border-bottom: 1px solid rgba(233, 233, 233, 1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 40px;
    box-sizing: border-box;
    .headerTitle {
      display: flex;
      span {
        color: #999999;
        font-size: 14px;
      }
    }
    .headerHint {
      font-size: 14px;
      color: #999999;
      span {
        position: relative;
        top: 3px;
        left: -3px;
        color: red;
      }
    }
  }
  .roleDescription,
  .roleName {
    margin-top: 30px;
    padding: 20px 30px;
    span {
      position: relative;
      top: 3px;
      left: -3px;
      color: red;
    }
    .title {
      font-size: 14px;
      color: #333333;
    }
    .el-row {
      display: flex;
      align-items: flex-end;
      margin-top: 15px;
      line-height: 32px;
    }
    .hint {
      height: 100%;
      margin-left: 10px;
      color: #999999;
    }
  }

  .menu {
    padding: 0 10px;
    margin-top: 30px;
    padding-bottom: 100px;
    .menuTitle {
      border-bottom: 1px solid rgba(233, 233, 233, 1);
      height: 30px;
      padding: 0 20px;
    }
    .elTree {
      margin: 30px 0 0 30px;
    }
  }

  .handle {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    .btn {
      padding-right: 30px;
      float: right;
    }
  }
}
</style>
